module.exports = __webpack_public_path__ + "img/3.7789e97c.jpg";